import _toConsumableArray from 'babel-runtime/helpers/toConsumableArray';
import _defineProperty from 'babel-runtime/helpers/defineProperty';
import _extends from 'babel-runtime/helpers/extends';
import { jsonResponse } from 'fetch-utilities';

var PENDING = "store/terms/PENDING";
var LOADING = "store/terms/LOADING";
var LOADED = "store/terms/LOADED";
var SET = "store/terms/SET";
var ADD = "store/terms/ADD";
var SET_ACTIVE = "store/terms/SET_ACTIVE";

var initialState = {
  state: PENDING,
  activeTerm: {},
  data: [],
  status: {}
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case LOADING:
      return _extends({}, state, {
        error: false,
        state: action.type,
        data: action.payload || state.data
      });

    case LOADED:
      return _extends({}, state, {
        state: action.type,
        error: action.error,
        data: action.error ? state.data : action.payload,
        errorData: action.error ? action.payload : null,
        status: action.error ? state.status : action.payload.reduce(function (acc, term) {
          return _extends({}, acc, _defineProperty({}, term.id, action.checked));
        }, {})
      });

    case ADD:
      if (typeof action.payload === "undefined") {
        return state;
      }

      return _extends({}, state, {
        data: [].concat(_toConsumableArray(state.data), [action.payload]),
        status: _extends({}, state.status, _defineProperty({}, action.payload.id, false))
      });

    case SET_ACTIVE:
      return _extends({}, state, {
        activeTerm: action.activeTerm
      });

    case SET:
      return _extends({}, state, {
        status: _extends({}, state.status, _defineProperty({}, action.termId, action.value))
      });

    default:
      return state;
  }
}

var load = function load() {
  var checked = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  return function (dispatch, _getState, client) {
    dispatch({
      type: LOADING
    });

    dispatch({
      type: LOADED,
      payload: client("/checkout_terms").then(jsonResponse),
      checked: checked
    });
  };
};

var set = function set(termId, value) {
  return {
    type: SET,
    termId: termId,
    value: value
  };
};

var setActive = function setActive(term) {
  return {
    type: SET_ACTIVE,
    activeTerm: term
  };
};

var add = function add(term) {
  return function (dispatch, getState, client) {
    if (getState().terms.data.some(function (t) {
      return t.id === term.id;
    })) {
      return;
    }

    dispatch({
      type: ADD,
      payload: term
    });
  };
};

export { PENDING, LOADING, LOADED, SET, ADD, SET_ACTIVE, load, set, setActive, add };
export default reducer;
